import styled from 'styled-components/native'

type StyledButtonProps = {
  selected?: boolean
}

export const CheckboxStyledContainer = styled.View<any>`
  height: ${({ theme }) => theme.buttons.sizes.md}px;
  flex-direction: row;
  justify-content: center;
  align-items: center;
`

export const StyledSquare = styled.View<StyledButtonProps>`
  height: ${({ theme }) => theme.buttons.sizes.xs}px;
  width: ${({ theme }) => theme.buttons.sizes.xs}px;
  border-radius: ${({ theme }) => theme.borderRadius.sm}px;
  padding: ${({ theme }) => theme.spacing.sm}px;
  border: 2px solid
    ${({ theme, selected }) => (selected ? theme.colors.v2primary : theme.colors.grey)};
  background-color: ${({ theme, selected }) =>
    selected ? theme.colors.v2primary : theme.colors.transparent};
  justify-content: center;
  align-items: center;
`
